<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaOperadores"
      :titulo="$t ('Operadores')"
      icono="mdi-account-key"
      tabla="ope"
      :campos="['id_ope-', 'corele+', 'nom+', 'id_rolope', 'fecalt-', 'ultinises', 'blo-']"
      :campos-filtrables="['id_rolope']"
      busqueda-rapida
      :titulo-crud="$t ('operador')"
      permitir-anadir
      permitir-modificar
      permitir-eliminar
    >
      <template v-slot:[`item.nom`]="{ item }">
          {{ item.nom }}
          <span v-if="item.blo != 0"><v-icon color="orange">mdi-lock</v-icon></span>
      </template>
    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  data() {
    return {

    }
  },
  methods: {
  }
};
</script>

<style>
</style>